import { Component, computed, input, output, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { getReadoutFrequency, MeterRole, PartnerModel, ReadoutFrequency } from '@core/models';
import { CardComponent } from '@custom-components/general/card/card.component';
import { CardGridComponent } from '@custom-components/general/card-grid';
import { DetailFieldComponent } from '@custom-components/general/detail-field';
import { MyCompanyDefaultMeterRoleComponent } from '../my-company-default-meter-role/my-company-default-meter-role.component';
import { TagComponent } from '@custom-components/general/tag/tag.component';
import { InfoBannerComponent } from '@custom-components/feedback/info-banner/info-banner.component';

@Component({
  selector: 'xemex-my-company-general-tab',
  imports: [
    TranslateModule,
    CardComponent,
    CardGridComponent,
    DetailFieldComponent,
    MyCompanyDefaultMeterRoleComponent,
    TagComponent,
    InfoBannerComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './my-company-general-tab.component.html',
})
export class MyCompanyGeneralTabComponent {
  companyDetail = input<PartnerModel>();
  isLoading = input<boolean>(false);
  isSavingDefaultMeterRole = input<boolean>(false);
  userRole = input<string | undefined>();
  /** When true (current user is a Xemex user), the default meter role and readout frequency
   * cards are hidden — Xemex isn't a partner, so neither setting applies to it (RDT-1019). */
  isXemex = input<boolean>(false);

  updateDefaultMeterRole = output<MeterRole>();

  readoutFrequency = computed((): ReadoutFrequency => getReadoutFrequency(this.companyDetail()));
}
